export default "__VITE_ASSET__d3cbALvb__"